<div class="h-100 w-100 m-0 row bg-custom-primary">
    <div class="col-md-7 form-container px-4 py-3">
        <div class="d-flex justify-content-between">
            <div class="logo">
                <img [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="logo" width="70px">
            </div>
        </div>
        <div class="h-100 row align-items-center">
            <div class="col-12 text-center">
                <h2 *ngIf="showMsg">Please close the alex app now.</h2>
                <h2 *ngIf="errorMessage">{{errorMessage}}</h2>
            </div>
        </div>
    </div>
    <div class="h-100 col-md-5 bg-cover position-relative bg-co d-none d-md-block">
        <cva-form-template></cva-form-template>
    </div>
</div>
